import { useEffect, useState } from 'react';
import './CookieConsent.css';
import { Cookie } from 'lucide-react';

const STORAGE_KEY = 'ornoir_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(STORAGE_KEY);
    if (!choice) setVisible(true);
  }, []);

  const choose = (value: 'accepted' | 'refused') => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-label="Consentement aux cookies">
      <div className="cookie-consent-inner">
        <Cookie size={22} strokeWidth={1.6} className="cookie-consent-icon" />
        <p className="cookie-consent-text">
          Nous utilisons des cookies pour améliorer votre expérience, mesurer l'audience et personnaliser nos publicités.
          En continuant, vous acceptez notre utilisation des cookies.
        </p>
        <div className="cookie-consent-actions">
          <button className="cookie-consent-btn cookie-consent-refuse" onClick={() => choose('refused')}>
            Refuser
          </button>
          <button className="cookie-consent-btn cookie-consent-accept" onClick={() => choose('accepted')}>
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
